import React from 'react';
import AsyncSelect from 'react-select/async';
import PropTypes from 'prop-types';

import { searchCallLists } from 'components/contacts/api';
import 'styles/entity_selector.scss';

import CallListOption from './associated_call_list_selector/call_list';

export default class AssociatedCallListSelector extends React.Component {
  static propTypes = {
    callListItems: PropTypes.array,
    onCreateTaskListItem: PropTypes.func,
    onModelAdded: PropTypes.func.isRequired
  };

  loadCallLists = (inputValue, callback) => {
    searchCallLists(inputValue, (callLists) => {
      const { callListItems } = this.props;

      const options = callLists.filter((callList) => {
        const task = callListItems.find(task => task.taskListId === callList.id);
        return !task || task._destroy;
      }).map((callList) => {
        return { value: callList.id, label: callList.name, type: 'Contacts::TaskList' };
      });
      callback(options);
    });
  }

  loadTaskListOptionsWithCreate = (inputValue, callback) => {
    const { onCreateTaskListItem } = this.props;

    const createCallList = {
      type: 'addCallListItem',
      label: 'Create Call List',
      onClick: onCreateTaskListItem
    };

    if (inputValue) {
      this.loadCallLists(inputValue, (options) => {
        callback([...options, createCallList]);
      });
    } else {
      callback([createCallList]);
    }
  }

  loadCallListOptions = (inputValue, callback) => {
    const { onCreateTaskListItem } = this.props;
    if (onCreateTaskListItem) {
      this.loadTaskListOptionsWithCreate(inputValue, callback);
    } else {
      this.loadCallLists(inputValue, callback);
    }
  }

  onSelected = (selection) => {
    const { onModelAdded } = this.props;
    if (selection.type === 'addCallListItem') {
      return undefined;
    }

    onModelAdded({
      name: selection.label,
      taskListId: selection.value
    });
  }

  render() {
    const { onCreateTaskListItem } = this.props;
    return (
      <AsyncSelect
        autoFocus
        className="entity-selector"
        components={{ Option: CallListOption }}
        defaultOptions={!!onCreateTaskListItem}
        loadOptions={this.loadCallListOptions}
        placeholder="Search Lists ..."
        value=""
        onChange={this.onSelected}
      />
    );
  }
}
